import getFlattenedEntry from './get-flattened-entry'

const getFlattenedEntries = entries => entries.map(getFlattenedEntry)

export default getFlattenedEntries
